import styled from '@emotion/styled';

// Shared look of the small module panels in Työpaja (report step, pivots v2).
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #ddd;
  font-size: 14px;
`;

export const Facts = styled.dl`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 16px;
  margin: 0;

  dt { color: rgba(255, 255, 255, 0.5); }
  dd { margin: 0; }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

// Transient $props stay off the DOM, also when rendered as={Link}.
export const ActionLink = styled('a', { shouldForwardProp: (prop) => !prop.startsWith('$') })`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 8px 14px;
  border-radius: 8px;
  background: ${p => (p.$primary ? '#2563eb' : 'rgba(255, 255, 255, 0.06)')};
  border: 1px solid ${p => (p.$primary ? '#2563eb' : '#333')};
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;

  &:hover { filter: brightness(1.1); }
  &:disabled { opacity: 0.5; cursor: wait; }
`;

export const Muted = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
`;

export const ErrorText = styled.p`
  margin: 0;
  color: #f87171;
  font-size: 13px;
`;
